import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { canAccessBms } from "../utils/permissions";

const BmsRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useSelector((state: RootState) => state.auth);
  if (!canAccessBms(user)) {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
};

export default BmsRoute;
